import { useCallback, useState } from 'react';

import type { SliderValue } from './calculator';

/** Form state for a set of sliders, with a setter factory per field. */
export default function useSliderInput<Input extends Record<keyof Input, SliderValue>>(
    initial: Input,
) {
    const [input, setInput] = useState<Input>(initial);

    const setField = useCallback(
        (field: keyof Input) => (value: number) => {
            setInput((previous) => ({ ...previous, [field]: value }));
        },
        [],
    );

    return [input, setField] as const;
}
